// extracted by mini-css-extract-plugin
module.exports = {"AppLogoContainer":"LoadingData_AppLogoContainer__qkETp","AppLogo":"LoadingData_AppLogo__WRIcw","AppLogoSpin":"LoadingData_AppLogoSpin__CF204"};